function init() {

  const customSelectElements = Array.from(document.querySelectorAll('.customselect'));

  //loop all custom selectboxes
  if (customSelectElements) {
    customSelectElements.map((select) => {

      let customSelectIntro                         = select.querySelector('.customselect__intro');
      let customSelectAlltext                       = select.querySelector('.customselect__alltext');
      let customSelectCounter                       = select.querySelector('.customselect__count');
      let customSelectDropdownElement               = select.querySelector('.customselect__dropdown');
      let customSelectDropdownElementOpenClassName  = 'customselect__dropdown--open';
      let customSelectActiveClassName               = 'customselect__intro--active';

      // add event listener to dropdown customselect
      if (customSelectIntro && customSelectDropdownElement) {
        customSelectIntro.addEventListener('click', (e) => {
          e.preventDefault();
          changeDropdownState('open');
          document.addEventListener('click', customSelectClickOutside);
        });

        // close dropdown when clicked outside
        const customSelectClickOutside = function(e) {
          let isClickInside = customSelectDropdownElement.contains(e.target) || customSelectIntro.contains(e.target);
          if (!isClickInside) {
            changeDropdownState('close');
            document.removeEventListener('click', customSelectClickOutside);
          }
        }
      }

      // count dropdown checked checkboxes
      if (customSelectDropdownElement && customSelectCounter) {
        let checkboxes = Array.from(customSelectDropdownElement.querySelectorAll('.cs-cb'));
        if (checkboxes) {
          checkboxes.map((checkbox) => {
            checkbox.addEventListener('click', (e) => {
              countCheckedCheckboxes(checkboxes, customSelectCounter, customSelectAlltext);
            });
          });
          countCheckedCheckboxes(checkboxes, customSelectCounter, customSelectAlltext);
        }
      }

      function changeDropdownState(state) {
        switch (state) {
          case 'open':
            customSelectDropdownElement.classList.add(customSelectDropdownElementOpenClassName);
            customSelectIntro.classList.add(customSelectActiveClassName);
            customSelectDropdownElement.focus();
          break;

          case 'close':
            customSelectDropdownElement.classList.remove(customSelectDropdownElementOpenClassName);
            customSelectIntro.classList.remove(customSelectActiveClassName);
          break;
        }
      }

    });
  }

  //count checkboxes and display
  function countCheckedCheckboxes(checkboxesArray, displayCountElement, displayAlltextElement) {
    const customSelectAlltextShowClassName = 'customselect__alltext--show';
    const customSelectCounterShowClassName = 'customselect__count--show';
    let count = 0;

    checkboxesArray.map((checkbox) => {
      if (checkbox.checked == true){
        count++;
      }
    });
    displayCountElement.innerHTML = count;

    //show all text if checkbox count and selected count match
    if (displayAlltextElement && (checkboxesArray.length === count)) {
      displayAlltextElement.classList.add(customSelectAlltextShowClassName);
      displayCountElement.classList.remove(customSelectCounterShowClassName);
    } else {
      displayAlltextElement.classList.remove(customSelectAlltextShowClassName);
      displayCountElement.classList.add(customSelectCounterShowClassName);
    }
  }

}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Customselect.js